<template lang="html">
  <router-link :to="{ name: 'game' }" class="app-logo">
    <span class="name">{{ appName }}</span>
  </router-link>
</template>

<script>
import { appName, appDomain } from '@/constants';

export default {
  name: 'AppLogo',

  data() {
    return {
      appName,
      appDomain,
    };
  },
};
</script>

<style scoped lang="scss">
.app-logo {
  text-decoration: none;
  color: inherit;
}

.name {
  font-weight: bold;
}
</style>
